import { useEffect, useState } from 'react';
import { CommonHelper } from 'src/utils/commonHelper';
import InstagramPostPreview from './instagram-post-preview.component';
import InstagramReelsPreview from './instagram-reels-preview.component';
import InstagramStoryPreview from './instagram-story-preview.component';

const InstagramPreviewOrganize = ({ postType, previewData, profileId }) => {
  const [data, setData] = useState({});
  useEffect(() => {
    if (!previewData || !profileId) return;
    let data = previewData[profileId].data;
    for (var i = 0; i < data.length; i++) {
      if (data[i].post_type === postType) {
        data[i].media_data = CommonHelper.ProcessMediaUrl(data[i].media_url);
        setData(data[i]);
      }
    }
  }, [postType, previewData, profileId]);

  return (
    <>
      {data && data?.post_type === 'post' && <InstagramPostPreview data={data} />}
      {data && data?.post_type === 'reels' && <InstagramReelsPreview data={data} />}
      {data && data?.post_type === 'story' && <InstagramStoryPreview data={data} />}
    </>
  );
};

export default InstagramPreviewOrganize;
